/**
 * V2 resolves poster and backdrop server-side (ADR 0027, ADR 0029): `posterPath` / `backdropPath` is the
 * Film Artwork for the locale and cinema the movie was fetched for, so it always comes first, and null
 * means there is none — the client ranks nothing over it (CIN-15406). The client ladder only orders the
 * rest of a gallery behind it, so the language/country options never change the served image on V2.
 *
 * Its own zero-dependency module so the package's node test runner can load it; `movie-helper` cannot
 * be, since its imports reach `.tsx` files.
 */
export function servedImageFirst(servedPath: string | null | undefined, ladderPaths: string[]): string[] {
    if (!servedPath) {
        return [];
    }
    return [servedPath, ...ladderPaths.filter((path) => path !== servedPath)];
}
